/**
 * O nome exibido para os arquivos do paciente vem do cadastro de complementos da
 * clínica (tabela COMPLEMENTO do Serverodonto). Enquanto o complemento "cefxMed*"
 * não estiver cadastrado, o relatório de medidas fica sem descrição própria.
 *
 * Aqui garantimos o rótulo correto no Serodonto a partir do nome do arquivo.
 */
const PREFIXO_MEDIDAS = "cefxmed";

export function ehRelatorioDeMedidas(complemento?: string): boolean {
  return (complemento || "").toLowerCase().startsWith(PREFIXO_MEDIDAS);
}

export function nomeImagemPaciente(imagem?: {
  nome?: string;
  complemento?: string;
}): string {
  if (!imagem) return "";
  if (ehRelatorioDeMedidas(imagem.complemento)) return "Relatório de Medidas";
  return imagem.nome || "";
}
